import ApiService from './api.service'

const ReportService = {    
  get(id, publicCode, baseReports) {
      return ApiService.get('api/reports', {
          params: {
            Id: id,
            PublicCode: publicCode,
            BaseReports: baseReports
          }
      })
  },

  getById(id) {
    return ApiService.get(`api/reports/${id}`)
},

  clone(id, asParent, publicCode, reportName, reportType) {
    let report = {
      id: id,
      asParent: asParent,
      publicCode: publicCode,
      reportName: reportName,   
      reportType: reportType   
    }
    return ApiService.post(`/api/reports/clone`, report)
  },

  create(asParent, publicCode, reportName, reportType, data) {
    let report = {
      asParent: asParent,
      publicCode: publicCode,
      reportName: reportName,
      reportType: reportType,
      data: data
    }
    return ApiService.post(`/api/reports`, report)
  },

  update(id, publicCode, reportName, reportType, data) {
    let report = {
      id: id,
      publicCode: publicCode,
      reportName: reportName,
      reportType: reportType,
      data: data
    }
    return ApiService.put(`/api/reports`, report)
  },

  delete(id) {
    return ApiService.delete(`/api/reports/${id}`)
  },

  /////////////////////////////////////////////////

  getMeterStatements(projectByObjectsId, meterId, meterSerialNumber, meterTypeId, energyMeterTypeCode, addressSearchString, personalAccount, transportSerialNumber, dateStatementsFrom, dateStatementsTo, countRecords) {
    return ApiService.get('api/reports/meter-statements', {
      params: {
        ProjectByObjectsId: projectByObjectsId,
        MeterId: meterId,
        MeterSerialNumber: meterSerialNumber,
        MeterTypeId: meterTypeId,
        EnergyMeterTypeCode: energyMeterTypeCode,
        AddressSearchString: addressSearchString,
        PersonalAccount: personalAccount,
        TransportSerialNumber: transportSerialNumber,
        DateStatementsFrom: dateStatementsFrom,
        DateStatementsTo: dateStatementsTo,
        CountRecords: countRecords
      }
    })
  },

  getMeterConsumptions(projectByObjectsId, meterId, meterSerialNumber, meterTypeId, energyMeterTypeCode, addressSearchString, personalAccount, transportSerialNumber, dateStatementsFrom, dateStatementsTo, countRecords, periodTypeCode) {
    return ApiService.get('api/reports/meter-consumptions', {
      params: {
        ProjectByObjectsId: projectByObjectsId,
        MeterId: meterId,
        MeterSerialNumber: meterSerialNumber,
        MeterTypeId: meterTypeId,
        EnergyMeterTypeCode: energyMeterTypeCode,
        AddressSearchString: addressSearchString,
        PersonalAccount: personalAccount,
        TransportSerialNumber: transportSerialNumber,
        DateStatementsFrom: dateStatementsFrom,
        DateStatementsTo: dateStatementsTo,
        CountRecords: countRecords,
        PeriodTypeCode: periodTypeCode
      }
    })
  },

  getThermalMeterStatements(projectByObjectsId, meterId, meterSerialNumber, meterTypeId, addressSearchString, personalAccount, transportSerialNumber, dateStatementsFrom, dateStatementsTo, countRecords) {
    return ApiService.get('api/reports/thermalmeter-statements', {
      params: {
        ProjectByObjectsId: projectByObjectsId,
        MeterId: meterId,
        MeterSerialNumber: meterSerialNumber,
        MeterTypeId: meterTypeId,
        AddressSearchString: addressSearchString,
        PersonalAccount: personalAccount,
        TransportSerialNumber: transportSerialNumber,
        DateStatementsFrom: dateStatementsFrom,
        DateStatementsTo: dateStatementsTo,
        CountRecords: countRecords
      }
    })
  },

  getThermalMeterConsumptions(projectByObjectsId, meterId, meterSerialNumber, meterTypeId, addressSearchString, personalAccount, transportSerialNumber, dateStatementsFrom, dateStatementsTo, countRecords, periodTypeCode) {
    return ApiService.get('api/reports/thermalmeter-consumptions', {
      params: {
        ProjectByObjectsId: projectByObjectsId,
        MeterId: meterId,
        MeterSerialNumber: meterSerialNumber,
        MeterTypeId: meterTypeId,
        AddressSearchString: addressSearchString,
        PersonalAccount: personalAccount,
        TransportSerialNumber: transportSerialNumber,
        DateStatementsFrom: dateStatementsFrom,
        DateStatementsTo: dateStatementsTo,
        CountRecords: countRecords,
        PeriodTypeCode: periodTypeCode
      }
    })
  }
}

export default ReportService